import { memo } from 'react';
import SVGBase, { type SVGComponentProps } from './SVGBase';

const path = <path d="M19.333 22.667l-6.667-6.667 6.667-6.667z" />;

function ArrowLeft({
  className,
  title = 'Arrow Left',
}: SVGComponentProps) {
  return (
    <SVGBase
      className={className}
      labeledBy="arrow-left-svg"
      path={path}
      title={title}
    />
  );
}

export default memo(ArrowLeft);
